























import { defineComponent } from "@vue/composition-api"
import Title from "@/app/components/common/Title.vue"
import Content from "@/app/components/common/Content.vue"
import { FacilityModel } from "@/app/models/facility.model"

export default defineComponent({
  components: {
    Title,
    Content,
  },
  props: {
    facility: {
      type: Object as () => FacilityModel,
      required: true,
    },
  },
})
